import { TxOverview } from '../../logic/createTxOverview'
import { Token } from '@/domain/types/Token'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface ConvertStablesTransactionOverviewProps {
  inToken: Token
  outToken: Token
  txOverview: TxOverview
}

function ConvertStablesTransactionOverview({ txOverview }: ConvertStablesTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    const placeholder = '-'

    return (
      <TransactionOverview>
        <TransactionOverview.Row>
          <TransactionOverview.Label>Outcome</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      </TransactionOverview>
    )
  }

  const { outcome } = txOverview

  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.TokenAmount
          token={outcome.token}
          amount={outcome.value}
          usdAmount={outcome.usdValue}
          amountDataTestId={testIds.dialog.transactionOverview.outcome}
          usdAmountDataTestId={testIds.dialog.transactionOverview.outcomeUsd}
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  ConvertStablesTransactionOverview as TransactionOverview,
  type ConvertStablesTransactionOverviewProps as TransactionOverviewProps,
}
